import { gql } from '@apollo/client'

export const ACCOUNT_FRAGMENTS = gql`
  fragment AccountFragments on Account {
    id
    billingStatus
    status
    integrations {
      recurlyId
      salesforceId
    }
    transition {
      name
      planId
      planSku
      usageAmount
      frequency
      activationDate
      plan {
        rank
      }
    }
  }
`

export const SUBSCRIPTIONS_FRAGMENTS = gql`
  fragment SubscriptionsFragments on AccountSubscription {
    planId
    planSku
    name
    amount
    startDate
    endDate
    activationDate
    nextBillDate
    type
    frequency
    status
    billingProvider
    plan {
      isTrial
      requiresBilling
      rank
    }
  }
`

export const COUPON_FRAGMENTS = gql`
  fragment CouponFragments on Coupon {
    name
    status
    plans {
      sku
      name
    }
    discount {
      amount
    }
  }
`

export const RENEWAL_PREVIEW_FRAGMENTS = gql`
  fragment RenewalPreviewFragments on RenewalPreviewResponse {
    dueDate
    totals {
      price
      discount
      subTotal
      tax
      total
    }
  }
`

export const REACTIVATE_ACCOUNT = gql`
  mutation reactivateAccount($couponCode: String) {
    reactivateAccount(couponCode: $couponCode)
  }
`

export const REDEEM_COUPON = gql`
  mutation redeemCoupon($couponCode: String) {
    redeemCoupon(couponCode: $couponCode) {
      id
      subscriptionId
    }
  }
`

export const CANCEL_SUBSCRIPTION = gql`
  mutation cancelSubscription {
    cancelSubscription
  }
`

export const CANCEL_TRANSITION = gql`
  mutation cancelTransition {
    cancelTransition
  }
`

export const COUPON_QUERY = gql`
  query coupon($couponCode: String) {
    coupon(couponCode: $couponCode) {
      ...CouponFragments
    }
  }
  ${COUPON_FRAGMENTS}
`

export const RENEWAL_PREVIEW_QUERY = gql`
  query renewalPreview {
    renewalPreview {
      ...RenewalPreviewFragments
    }
  }
  ${RENEWAL_PREVIEW_FRAGMENTS}
`

export const ACCOUNT_QUERY = gql`
  query account {
    account {
      ...AccountFragments
    }
  }
  ${ACCOUNT_FRAGMENTS}
`

export default {}
